import * as $ from 'jquery';
import * as fileInput from 'Modules/fileInput';
import * as formValidation from 'Modules/formValidation';


declare const grecaptcha: any;

namespace BHW.downloadImage {
	const POST_DOWNLOADIMAGES = '/api/downloadimage/product-images';	
	
	let $downloadProductImages = $('#downloadProductImages');
	let $slug = $('#product-slug');
	let $variant = $('#product-variant');
	let url;

	let submitEventListener = function () {
		$downloadProductImages.on('click', function (e) {
			e.preventDefault();

			
			let data = {
				slug: $slug.val(),
				variant: $variant.val(),
			};
			$.ajaxSetup({
				xhrFields: {
					responseType: 'blob'
				}
			});
			$.get(POST_DOWNLOADIMAGES, data)
				.done(function (data) {					
					//saveData(data, 'ProductImages.zip');
					var a = document.createElement('a');
					var url = window.URL.createObjectURL(data);
					a.href = url;
					a.download = 'ProductImages_'+$variant.val()+'.zip';
					a.click();
					window.URL.revokeObjectURL(url);
				})				

			
		});
	};
	
	

	const saveData = (() => {
	  const a = document.createElement('a');
	  //a.style = 'display: none';
	  document.body.appendChild(a);

	  return (data, fileName, type = 'octet/stream') => {
		const blob = new Blob([data], { type });

		//if (navigator.msSaveBlob) {
		  //return navigator.msSaveBlob(blob, fileName);
		//}

		if (url) {
		  // Keep at most 1 blob around by removing the last used one.
		  URL.revokeObjectURL(url);
		}

		url = URL.createObjectURL(blob);
		a.href = url;
		a.download = fileName;
		a.click();
		return true;
	  };
	})();
	
	export const init = () => {
		submitEventListener();

	};
}
document.addEventListener("DOMContentLoaded", () => {
	BHW.downloadImage.init();
});

